/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { EmployerPrefillResponse } from '@/services/requests/generated/types.gen';

/**
 * The industry to fill after an employer was chosen, if any.
 *
 * Plan 2026-10-28, §4.5: choosing an employer suggests the industry most
 * used by the agency's other clients there, and only ever fills an empty
 * field. What the broker already typed is never overwritten.
 *
 * @param currentIndustry - What the industry field holds now.
 * @param response - The employer-prefill answer.
 * @returns The industry to set, or null to leave the field alone.
 */
export function industryToPrefill(
  currentIndustry: string | undefined,
  response: EmployerPrefillResponse | null | undefined,
): string | null {
  if (currentIndustry?.trim()) return null;
  const suggested = response?.values?.personal_info?.industry?.trim();
  return suggested || null;
}
